import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { TODO } from '@/types'

const emptyBeginningOfOurStory = (): TODO => ({
  busStopPresent: null,
  busStopChallenges: null
})

export const useBeginningOfOurStoryStore = defineStore('beginningOfOurStory', () => {
  const beginningOfOurStory = ref(emptyBeginningOfOurStory())

  const clearBeginningOfOurStory = () => {
    beginningOfOurStory.value = emptyBeginningOfOurStory()
  }

  const setBeginningOfOurStory = (fields: TODO) => {
    if (!fields) return
    beginningOfOurStory.value = {
      ...beginningOfOurStory.value,
      ...fields
    }
  }

  return {
    beginningOfOurStory,
    clearBeginningOfOurStory,
    setBeginningOfOurStory
  }
})
